import React from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const ProClientMedicationDetails = ({formModel})=>{

    return <div>
        <DataTable value={formModel}  responsiveLayout="scroll">
            <Column field="startDateTime" header="Start Date & Time"></Column>
            <Column field="stopDateTime" header="Stop Date & Time"></Column>
            <Column field="orderStatus" header="Order Status" ></Column>
            <Column field="generic" header="Generic"></Column>
            <Column field="brand" header="Brand" ></Column>
            <Column field="ndcId" header="NDC ID"></Column>
            <Column field="form" header="Form"></Column>
            <Column field="strength" header="Strength"></Column>
            <Column field="dose" header="Dose"></Column>
            <Column field="doseUnit" header="Dose Unit"></Column>
            <Column field="route" header="Route"></Column>
            <Column field="timing" header="Timing"></Column>
            <Column field="instruction" header="Instructions"></Column>          
        </DataTable>
    </div>

}

export default ProClientMedicationDetails;